<template>
  <div class="approval">
    <div class="sift">
      <div class="title">审批查询</div>
      <div class="inquire">
        <el-form :inline="true" :model="formInline" class="demo-form-inline" size="small">
          <el-form-item>
            <strong slot="label">名称</strong>
            <el-input
              v-model="formInline.name"
              placeholder="请输入名称"
              clearable
              @keyup.enter.native="inquire"
              @clear="inquire"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <strong slot="label">代码</strong>
            <el-input
              v-model="formInline.code"
              placeholder="请输入代码"
              clearable
              @keyup.enter.native="inquire"
              @clear="inquire"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="inquire" style="background:#0C75E5">查询</el-button>
            <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary" plain icon="el-icon-plus" @click="handleAdd" size="small">新建</el-button>
        <el-button icon="el-icon-edit-outline" plain type="success" :disabled="ids.length != 1" @click="handleEdit" size="small">编辑</el-button>
        <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="!ids.length" @click="handleDel">删除</el-button>
      </div>
    </div>
    <div class="main">
      <div class="title">审批列表</div>
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="name" label="审批流程名称" >
          <template slot-scope="scope">
            <a @click="handleDetail(scope.row)" class="link">{{scope.row.name}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="代码"></el-table-column>
        <el-table-column prop="code" label="发布类型">
          <template slot-scope="scope">
            <DictTag :options="dropDown.reletype" :value="scope.row.reletype" isStyle/>
          </template>
        </el-table-column>
        <el-table-column prop="isDoneFormal" label="生成正式单据" align="center">
          <template slot-scope="scope">
            {{scope.row.isDoneFormal == '1' ? '是': '否'}}
          </template>
        </el-table-column>
        <el-table-column prop="skipInitiator" label="跳过发起人" align="center">
          <template slot-scope="scope">
            {{scope.row.skipInitiator == '1' ? '是': '否'}}
          </template>
        </el-table-column>
        <el-table-column prop="skipApprover" label="跳过已审批人" align="center">
          <template slot-scope="scope">
            {{scope.row.skipApprover == '1' ? '是': '否'}}
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="描述" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              icon="el-icon-edit"
              type="text"
              @click.native.stop="handleEdit(scope.row)"
            >编辑
            </el-button>
            <el-button
              size="mini"
              icon="el-icon-delete"
              type="text"
              @click.native.stop="handleDel(scope.row)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[5, 10, 20, 30, 40]"
        :page-size="pageSize"
        layout="->, total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog v-dialog-drag
      :title="title"
      :visible.sync="dialogFormVisible"
      :append-to-body="true"
      width="40%"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
        label-position="left"
      >
        <el-form-item label="名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="发布状态" prop="reletype">
          <el-select v-model="ruleForm.reletype" placeholder="请选择发布状态" style="width:100%">
            <el-option v-for="(item, index) in dropDown.reletype" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述" prop="remarks">
          <el-input type="textarea" v-model="ruleForm.remarks" placeholder="请输入描述"></el-input>
        </el-form-item>
        <el-form-item label="生成正式单据" prop="isDoneFormal">
          <el-radio v-model="ruleForm.isDoneFormal" label="1">是</el-radio>
          <el-radio v-model="ruleForm.isDoneFormal" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="跳过发起人" prop="skipInitiator">
          <el-radio v-model="ruleForm.skipInitiator" label="1">是</el-radio>
          <el-radio v-model="ruleForm.skipInitiator" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="跳过已审批人" prop="skipApprover">
          <el-radio v-model="ruleForm.skipApprover" label="1">是</el-radio>
          <el-radio v-model="ruleForm.skipApprover" label="0">否</el-radio>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :loading="isLoading">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 审批详情 -->
    <el-dialog v-dialog-drag
      :title="cfAppData.name"
      :visible.sync="dialogViewVisible"
      :append-to-body="true"
      top="59px"
      width="90%"
    >
      <el-descriptions :column="2">
        <el-descriptions-item label="描述">
          {{cfAppData.remarks}}
        </el-descriptions-item>
        <el-descriptions-item label="发布类型">
          <DictTag :options="dropDown.reletype" :value="cfAppData.reletype"/>
        </el-descriptions-item>
      </el-descriptions>
      <el-tabs type="border-card" v-model="activeName">
        <el-tab-pane label="审批步骤" name="first">
          <Step v-if="activeName == 'first'" :cfappId="cfAppData.cfAppId" />
        </el-tab-pane>
        <el-tab-pane label="发起岗位" name="second">
          <Post v-if="activeName == 'second'" :cfappId="cfAppData.cfAppId" />
        </el-tab-pane>
        <el-tab-pane label="发起活动" name="third">
          <Activity v-if="activeName == 'third'" :cfappId="cfAppData.cfAppId" />
        </el-tab-pane>
        <!-- <el-tab-pane label="审批条件" name="forth">
          <Condition v-if="activeName == 'forth'" />
        </el-tab-pane> -->
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogViewVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import url from '@/config/url'
// import DictTag from '@/components/DictTag.vue'
import {mapState} from 'vuex'
import qs from 'qs'
import Step from '@/components/set/approval/Step.vue'
import Post from '@/components/set/approval/Post.vue'
import Activity from '@/components/set/approval/Activity.vue'
  export default {
    computed: {
      ...mapState({
        dropDown: (state) => state.dropDown.dropDown
      })
    },
    components: {
      // DictTag,
      Step,
      Post,
      Activity,
    },
    data() {
      return {
        formInline: {
          name: '',
          code: ''
        },
        tableData: [],
        loading: true,
        dialogFormVisible: false,
        ruleForm: {
          name: '',
          reletype: "",
          remarks: '',
          skipInitiator: '',
          isDoneFormal: ''
        },
        rules: {
          name: [{ required: true, message: "请输入名称", trigger: "submit" }],
          reletype: [{ required: true, message: "请选择发布状态", trigger: "submit" }],
        },
        // options: [],
        // 弹出层标题
        title: '',
        isLoading: false,
        ids: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
        cfAppData: {},
        activeName: 'first',
        cfAppId: null,
        dialogViewVisible: false
      }
    },
    created () {
      this.getList()
    },
    methods: {
      getList() {
        this.loading = true
        this.$http.get(url.getCfAppList, {params: {
          name: this.formInline.name,
          code: this.formInline.code,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }}).then(res => {
          this.loading = false
          if(res.data.code == 200) {
            // console.log(res);
            this.tableData = res.data.data.list
            this.total = res.data.data.total
          }
        })
        // 发布下拉
        if(!this.dropDown.reletype) {
          this.$http.get(url.getDataList, {params: {type: 'buss_reletype' }}).then(res => {
            if(res.data.code == 200) {
              this.$store.commit('setReletype', res.data.data)
            }
          })
        }
      },
      // 提交表单
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isLoading = true
            // 新增审批
            if(!this.ruleForm.cfAppId) {
              this.$http.post(url.addCfApp, qs.stringify(this.ruleForm)).then(res => {
                // console.log(res);
                this.isLoading = false
                if(res.data.code === 200) {
                  this.$message.success(res.data.msg);
                  this.pageNum = 1
                  this.getList()
                }
              })
            }else { // 编辑审批
              this.$http.post(url.editCfApp, qs.stringify(this.ruleForm)).then(res => {
                // console.log(res);
                this.isLoading = false
                if(res.data.code === 200) {
                  this.$message.success(res.data.msg);
                  this.pageNum = 1
                  this.getList()
                }
              })
            }
            this.dialogFormVisible = false;
          } else {
            return false;
          }
        });
      },
      // 新增
      handleAdd() {
        this.dialogFormVisible = true
        this.title = '新增审批'
        this.$nextTick(() => {
        // 清除表单校验效果
          this.$refs.ruleForm.clearValidate();
        })
        // 初始化表单内容
        for(let key in this.ruleForm) {
          this.ruleForm[key] = ''
        }
        this.ruleForm.reletype = this.dropDown.reletype[1].dictValue
      },
      // 修改
      handleEdit(row) {
        if(this.$refs.ruleForm) {
          this.$nextTick(() => {
            // 清除表单校验效果
            this.$refs.ruleForm.clearValidate();
          })
        }
        let cfAppId = row.cfAppId || this.ids[0]
        // console.log(row);
        this.dialogFormVisible = true
        this.title = '修改审批'
        this.$http.get(url.getCfApp, {params: {cfAppId}}).then(res => {
          // console.log(res);
          this.ruleForm = res.data.data
        })
      },
      // 删除
      handleDel(row) {
        let cfAppIds = row.cfAppId || this.ids.toString()
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post(url.removeCfApp, qs.stringify({cfAppIds})).then(res => {
            if(res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.pageNum = 1
              this.getList()
            }
          })

        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
      },
      // 查看详情
      handleDetail(row) {

        // this.$router.push('/set/approval/' + row.cfAppId)
        // let obj = {
        //   path: '/set/approval/' + row.cfAppId,
        //   name: 'approvalDetail',
        //   label: '审批详情',
        //   children: []
        // }
        // this.$store.commit("selectMenu", obj);
        this.$http.get(url.getCfApp, {params: {cfAppId: row.cfAppId}}).then(res => {
          // console.log(res);
          this.cfAppData = res.data.data
        })
        this.activeName = 'first'
        this.dialogViewVisible = true
      },
      // 查询按钮
      inquire() {
        this.pageNum = 1
        this.getList()
      },
      // 重置按钮
      reset() {
        for(let key in this.formInline) {
          this.formInline[key] = ""
        }
        this.pageNum = 1
        this.getList()
      },
      // 选择框事件
      handleSelectionChange(rows) {
        this.ids = rows.map(item => item.cfAppId)
        this.edit = rows.length === 1
        this.del = rows.length >= 1
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.pageNum = 1
        this.getList()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getList()
      },
    },
  }
</script>

<style lang="scss" scoped>
.approval {
  /* padding: 16px; */
  .sift, .main {
    background: #FFFFFF;
    box-shadow: 2px 3px 8px 0px rgba(208,208,208,0.5);
    border-radius: 11px;
    padding: 16px;
    position: relative;
    margin-bottom: 16px;
    .el-table {
      margin-bottom: 39px;
    }
  }
  .main {
    margin-bottom: 0;
  }
  .title {
    height: 14px;
    font-size: 14px;
    font-family: STHeitiSC-Medium, STHeitiSC;
    font-weight: 500;
    color: #282828;
    line-height: 14px;
    padding-left: 8px;
    border-left: #0c75e5 2px solid;
    margin-bottom: 16px;
    font-weight: bolder;
  }
}
</style>
